import type { GeneralError } from 'types';

const getErrorMessage = (error: GeneralError | unknown) => (error as GeneralError).errorMessage || (error as GeneralError).message || '';

export default getErrorMessage;
